import React from "react";
import Navbar from "../../components/common/Navbar";
import Banner from "./Banner";
import VerticalLines from "../../components/common/VerticalLines";
import AboutSection from "./AboutSection";
import ServiceSection from "./ServiceSection";
import FeatureSection from "./FeatureSection";
import FunfactSection from "./FunfactSection";
// import BlogSection from "./BlogSection";
import { Helmet } from 'react-helmet';

const index = () => {
  return (
    <div>
      <Helmet>
        <title>Roliox Alloys</title>
      </Helmet>
      <Navbar inner={false} />
      <div className="site-content">
        <section className="position-relative">
          <VerticalLines />
          <Banner />
          <ServiceSection />
          <FeatureSection />
          <AboutSection />
          {/* <FunfactSection /> */}
          {/* <BlogSection /> */}
        </section>
      </div>
    </div>
  );
};

export default index;
